import "../../src/assets/styles/Header.css";
import logo from "../imgs/logo.png";
import iconBack from "../icons/icon-back.png";
import imgTitleSupCskh from "../imgs/title-sup-cskh.png";
import imgTitleFullName from "../imgs/title-full-name.png";
import imgTitlePhone from "../imgs/title-phone.png";
import imgTitleEmail from "../imgs/title-email.png";
import imgTitleBank from "../imgs/title-bank.png";
import { useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
function Header({ isPageSearch, pageToAcction, data, currentPage }) {
  const navigate = useNavigate();
  const backToSearch = () => {
  if (pageToAcction && pageToAcction !== "/") return navigate(pageToAcction,  { state: data, replace: !!data?.lastBank });
  if (data?.lastBank) {
    // vào từ link có account + last_bank: đóng tab, trình duyệt chặn đóng thì về trang tìm kiếm như cũ
    window.close();
    setTimeout(() => { if (!window.closed) navigate("/"); }, 300);
    return;
  }
  if (pageToAcction) navigate(pageToAcction,  { state: data })
  else navigate("/");
  };

  return (
    <div>
      <div className="status-bar"></div>
      <div className="header">
        <div className="header-logo">
          {!isPageSearch && (
            <img
              className="img-icon-back"
              style={{ cursor: "pointer" }}
              src={iconBack}
              alt="icon-back"
              id="btn-back"
              onClick={backToSearch}
            />
          )}
          <HomeIcon
              sx={{
                position: "absolute",
                backgroundColor: "white",
                borderRadius: "50%",
                padding: 1,
                top: 12,
                right: 10,
                fontSize: 30,
                fill: "#fc8b00",
                cursor: "pointer",
              }}
              onClick={() => (window.location.href = data?.webSetting?.link_home || "https://f168m.com/")}
            />
          <div className="main-logo">
            <img src={logo} alt="logo"></img>
          </div>
        </div>
          {!currentPage && (
            <div className="main-title main-title-cskh">
              <img src={imgTitleSupCskh} alt="logo"></img>
            </div>
          )} 
          {/* {currentPage && (
            <div className="main-title main-title-cskh2">
              <img src={imgTitleSupCskh} alt="logo"></img>
            </div>
          )}  */}
        {
          {
            "full_name":
            <div className="main-title-text">
              <span>THAY ĐỔI HỌ VÀ TÊN</span>
              {/* <img src={imgTitleFullName} alt="logo"></img> */}
            </div>,
            "phone_number":
            <div className="main-title-text">
              <span>CẬP NHẬT SỐ ĐIỆN THOẠI</span>
            </div>,
            "email":
            <div className="main-title-text">
              <span>CẤP LẠI MẬT KHẨU ĐĂNG NHẬP</span>
            </div>,
            "bank":
            <div className="main-title-text">
              <span>THAY ĐỔI THÔNG TIN <br/>NGÂN HÀNG LIÊN KẾT</span>
            </div>,
            "confirm_account":
            <div className="main-title-text">
              <span>XÁC MINH TÀI KHOẢN</span>
            </div>,
          }[currentPage]
        }
        {/* <p>HỖ TRỢ KHÁCH HÀNG</p> */}
      </div>
    </div>
  );
}

export default Header;
